@if(!clickable()){
	@if(user.user().img){
		<div class="avatar">
		  <div class="w-12 rounded-full">
		  	<span>
			    <img [src]="img()" />
			</span>
		  </div>
		</div>
	}
	@else{
		<div class="avatar avatar-placeholder">
		  <div class="bg-neutral text-neutral-content w-12 rounded-full">
	    	 <span>{{inital() | uppercase}}</span>
		  </div>
		</div>
	}
}
@else if(user.user().img){
	<div class="avatar">
	  <div class="w-12 rounded-full">
	  	<a href="#" [routerLink]="router.get('my-acount')">
		    <img [src]="img()" />
		</a>
	  </div>
	</div>
}
@else{
	<div class="avatar avatar-placeholder">
	  <div class="bg-neutral text-neutral-content w-12 rounded-full">
	  	<a href="#" [routerLink]="router.get('my-acount')">
	    	<span>{{inital() | uppercase}}</span>
	    </a>
	  </div>
	</div>
}